import { Icon } from "../components/Icon";
import { Upload01 } from "../icons/v2-stroke";
import { cn } from "../lib";
import anim from "../lottie/dragArea";
import Lottie from "lottie-react";
import React, { useEffect, useRef, useState } from "react";
/**
 * A full-surface visual overlay that signals a drop target during a
 * drag-and-drop file upload, toggled with isDragActive and labeled with title
 * and description. Use it to give clear feedback when a user drags files over
 * a region that accepts uploads; it only renders the cue and does not handle
 * the drop itself.
 * @summary Drag-and-drop upload overlay cue.
 */
export function DropzoneOverlay({
  description,
  isDragActive,
  title,
  visual = /*#__PURE__*/React.createElement(Icon, {
    visual: Upload01,
    size: "lg",
    className: "text-background"
  })
}) {
  const lottieRef = useRef(null);
  const [isActiveDelayed, setIsActiveDelayed] = useState(false);

  // This is used to delay the removal of the overlay when the user stops dragging.
  useEffect(() => {
    if (isDragActive) {
      setIsActiveDelayed(true);
    } else {
      const timeoutId = setTimeout(() => {
        setIsActiveDelayed(false);
      }, 400);
      return () => clearTimeout(timeoutId);
    }
  }, [isDragActive]);
  if (!isActiveDelayed) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn("absolute inset-0 z-50 flex h-full w-full flex-col items-center justify-center gap-0", "bg-background/80", "text-foreground"),
    onMouseLeave: () => {
      var _lottieRef$current, _lottieRef$current2, _lottieRef$current3;
      (_lottieRef$current = lottieRef.current) === null || _lottieRef$current === void 0 || _lottieRef$current.setDirection(-1);
      (_lottieRef$current2 = lottieRef.current) === null || _lottieRef$current2 === void 0 || _lottieRef$current2.setSpeed(2);
      (_lottieRef$current3 = lottieRef.current) === null || _lottieRef$current3 === void 0 || _lottieRef$current3.play();
    },
    onDrop: () => {
      var _lottieRef$current4, _lottieRef$current5;
      (_lottieRef$current4 = lottieRef.current) === null || _lottieRef$current4 === void 0 || _lottieRef$current4.setDirection(-1);
      (_lottieRef$current5 = lottieRef.current) === null || _lottieRef$current5 === void 0 || _lottieRef$current5.play();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Lottie, {
    lottieRef: lottieRef,
    animationData: anim,
    style: {
      width: `200px`,
      height: `200px`
    },
    loop: false,
    autoplay: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute",
    style: {
      top: `84px`,
      left: `84px`
    }
  }, visual)), /*#__PURE__*/React.createElement("div", {
    className: "heading-xl"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "text-base text-muted-foreground"
  }, description));
}
//# sourceMappingURL=DropzoneOverlay.js.map